import type { Mission } from '../missions.ts'

export const doj: Mission = {
  id: "doj",
  name: "U.S. Department of Justice",
  short: "DOJ",
  call: "Justice",
  kind: "department",
  url: "https://www.justice.gov/",
  established: 1870,
  palette: {
    primary: "#0a2240",
    secondary: "#07648d",
    accent: "#f5a800",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Justice.svg",
  },
  motif: "scales",
  mission: {
    text: "The mission of the Department of Justice is to uphold the rule of law, to keep our country safe, and to protect civil rights.",
    url: "https://www.justice.gov/about",
  },
  fact: {
    text: "The Judiciary Act of 1789 created the Office of the Attorney General, which evolved into the head of the Department of Justice.",
    url: "https://www.justice.gov/ag/about-office",
  },
  seal: {
    file: "public/seals/doj.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_Justice.svg",
  },
  identifier: {
    about: "https://www.justice.gov/about",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.justice.gov/oip",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/doj-rfk-building.jpg",
        small: "/media/doj-rfk-building-sm.jpg",
        alt: "The limestone Robert F. Kennedy Department of Justice Building along a wide avenue, framed by red autumn leaves and a clear blue sky.",
        title: "Robert F. Kennedy Department of Justice Building, Washington, D.C., 2015",
        creator: "Voice of America",
        source: "https://commons.wikimedia.org/wiki/File:US_Department_of_Justice_building_with_road.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/doj-main-library.jpg",
        small: "/media/doj-main-library-sm.jpg",
        alt: "A long library hall lined with wooden bookcases and law volumes beneath an ornate ceiling and wall murals.",
        title: "Main Library, Robert F. Kennedy Department of Justice Building, Washington, D.C.",
        creator: "Carol M. Highsmith, Library of Congress",
        source: "https://commons.wikimedia.org/wiki/File:Main_Library,_Robert_F._Kennedy_Department_of_Justice_Building,_Washington,_D.C_LCCN2010718995.tiff",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
